export { default } from './assignIn'



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/extend.js
// module id = 45
// module chunks = 0